import { useState, useEffect, useCallback } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

const useSettingsFetch = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(API_ENDPOINTS.interna.SelectDataSettingBcoChile);
      const json = await res.json();

      // ✅ Parsear el campo Settings
      const parsed = json.map((row) => ({
        ...row,
        Settings: typeof row.Settings === "string" ? JSON.parse(row.Settings) : row.Settings,
      }));

      setSettings(parsed);
      setError(null);
    } catch (err) {
      setError("Error al cargar configuraciones");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { settings, loading, error, refetch: fetchData };
};

export default useSettingsFetch;
